export default __webpack_public_path__ + "static/media/Routine.c65dcbbf.png";